import {translate, type TranslationKey} from "./i18n";

export class TranslatableError extends Error {
    public readonly name = 'TranslatableError';
    public readonly id: string;
    public readonly msg: string;

    constructor(options: {id?: string, msg?: string, cause?: unknown}) {
        let {id, msg, cause} = options;
        delete options.id;
        delete options.msg;
        if (!id) {
            id = 'generic'
        }
        if (!msg) {
            msg = cause instanceof Error ? cause.message : cause ? String(cause) : 'Unknown error';
        }
        const message = translateError(id, msg)
        super(message, options);
        this.id = id;
        this.msg = msg;
        if ("captureStackTrace" in Error) {
            Error.captureStackTrace(this, TranslatableError);
        }
    }
}
export function transformToTranslatableError(error: unknown): TranslatableError {
    if (error instanceof TranslatableError) {
        return error;
    } else {
        return new TranslatableError({cause: error});
    }
}

export function translateError(errorId?: string, msg?: string): string {
    if (!errorId) {
        errorId = 'generic';
    }
    if (errorId == 'failedDependency' && !!msg) {
        msg = translate(`dependencies.${msg}` as TranslationKey);
    }
    return translate(`errors.${errorId}` as TranslationKey, {msg: msg || ''});
}

export function isErrorRetryable(error: TranslatableError|string): boolean {
    const errorId = typeof error === 'string' ? error : error.id;
    return errorId !== 'rejected';
}
